import { Button, IconClose, IconedButton, Text } from '@bbl-digital/snorre-v2'
import { useFileuploadPickerContext } from '../context/useFileuploadPickerContext'
import { SimpleArchiveListDocumentModel } from 'shared/microServices/portalDocuments/models/SimpleArchiveListDocumentModel'
import { mapArchiveFile } from '../utils/mapper'
import FileIcon from '../components/FileIcon'

type FileItemProps = {
  file: SimpleArchiveListDocumentModel
}

const ArchiveFileItem = ({ file }: FileItemProps) => {
  const { removeFile, onChange, files, maxsizeInBytes, accept, reject } =
    useFileuploadPickerContext()

  const isFileAdded = files.some((f) => f.id === file.id)

  return (
    <div className="flex justify-between items-center border rounded-md border-border-subtle mb-1 p-1 gap-2">
      <div className="flex gap-1 items-center min-w-0">
        <FileIcon type={file.mimeType} className="ml-0 shrink-0" />
        <div className="flex flex-col items-start min-w-0 w-full">
          <Text className="truncate font-semibold w-full" title={file.title}>
            {file.title}
          </Text>
          <Text className="truncate w-full" title={file.filename}>
            {file.filename}
          </Text>
        </div>
      </div>

      {isFileAdded && (
        <IconedButton
          label="Fjern fil"
          variant="ghost"
          small
          icon={<IconClose />}
          onClick={() =>
            removeFile(mapArchiveFile(file, maxsizeInBytes, accept))
          }
        />
      )}

      {!isFileAdded && (
        <Button
          small
          variant="secondary"
          onClick={() =>
            onChange([mapArchiveFile(file, maxsizeInBytes, accept, reject)])
          }
          className="shrink-0"
        >
          Legg til
        </Button>
      )}
    </div>
  )
}

export default ArchiveFileItem
